// extracted by mini-css-extract-plugin
export default {"pageLayout":"Ua-z","mainContent":"Va-z","columnLayout":"Wa-z","columnLayoutFill":"Xa-z","columnLayoutLast":"Ya-z"};